import React from "react"

import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {lexicalChangeList} from "../../../../actions/change-list"

export default function ToolbarListMenu(props:any) {

    const onClick = (option:any) => {
        lexicalChangeList(props.menuParams.editor, props.menuParams.blockType, option.value)
    }

    return (
        <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
            {_.map(props.menuParams.options, (option:any, index:number)=>
                <PopoverMenuOption key      = {option.value}
                                   option   = {option}
                                   selected = {option.value === props.menuParams.blockType}
                                   onClick  = {onClick}/>
            )}
        </div>
    )
}